import { Injectable } from '@angular/core';
import { NodeSimpleResponse } from '@core/models/response-models/response-models';

import { ApiService } from './api.service';
import { BaseNodeService } from './base-node.service';
import { CacheManagementService } from './cache-management.service';
import { AppSettings } from '@core/library/app-settings';

/**
 * New service class for work orders
 *
 * @export
 * @class KmtAssetCategoryService
 * @extends {BaseService}
 */
@Injectable({
  providedIn: 'root',
})
export class KMTAnalyticsService extends BaseNodeService {
  constructor(
    public apiService: ApiService,
    public cacheService: CacheManagementService
  ) {
    super(apiService);
    this.BaseURL = AppSettings.URL_Analytics;
  }
  analyticsURL: string = '';
  fetchAnalyticsURL(trackLoading = false) {
    return this.analyticsURL
      ? this.analyticsURL
      : this.apiService
          .getAPI(this.BaseURL, '', trackLoading)
          .then((data: any) => {
            this.analyticsURL = data?.url || '';
            return this.analyticsURL;
          });
  }
  hasAnalyticsURL(trackLoading = false) {
    return this.analyticsURL
      ? true
      : this.apiService
          .getAPI(this.BaseURL, '', trackLoading)
          .then((data: any) => {
            this.analyticsURL = data?.url || '';
            return this.analyticsURL ? true : false;
          });
  }
}
